import m from "mithril";

import flagImg from './images/greenlandFlag.png'
import nuclearImg from './images/nuclear.png'
class LogBookPage {
  constructor(vnode) {
    this.getIndexClass = this._getIndexClass.bind(this);
    this.getZIndex = this._getZIndex.bind(this);
  }

  oninit(vnode) {
    let state = this;
    state.unredacted = false;
  }

  _getIndexClass(index, pageIndex) {
    if (index === pageIndex) return "is-future is-active";

    return index < pageIndex ? "is-past" : "is-future";
  }

  _getZIndex(index, pageIndex, total) {
    if (index === pageIndex - 1) return total + 1;
    if (index < pageIndex) return index + 1;

    return total - index + 1;
  }

  view(vnode) {
    let state = this;
    const { page, index, pageIndex, pageReadyIndex, pageTotal } = vnode.attrs;

    let pageClasses = [
      "log-book-page",
      index === 0 || index === pageTotal - 1 ? "mod-outer" : "mod-inner",
      state.getIndexClass(index, pageIndex),
      pageReadyIndex === index ? "is-ready" : "",
    ];

    const Front = page.front || null;
    const Back = page.back || null;

    return (
      <div
        className={pageClasses.join(" ")}
        // onclick={(e) => {
        //   e.stopPropagation();

        //   const i = index < pageIndex ? index : index + 1;
        //   if (i >= pageTotal) return;
        //   vnode.attrs.toggleLogBook(i);
        // }}
        style={{
          zIndex: state.getZIndex(index, pageIndex, pageTotal),
        }}
      >
        <div className="log-book-page-content">
          {Front && (
            <Front {...vnode.attrs} unredacted={vnode.attrs.unredacted} />
          )}
        </div>

        <div className="log-book-page-content mod-back">
          {Back && <Back {...vnode.attrs} />}
        </div>

        {page.hasTabs ? (
          <div
            className="log-book-tab"
            style={{ top: `${page.tabIndex * 3.5}vh` }}
            onclick={(e) => {
              e.stopPropagation();
              if (index >= pageTotal) return;
              vnode.attrs.toggleLogBook(index);
            }}
          >
            <div className="log-book-tab-face">
              <img
                src={page.tabImg}
                className={`log-book-tab-img ${page.tabImgOffset}`}
              />
              <div
                className="log-book-tab-marker mod-front"
                style={`background: ${page.tabColor}`}
              />
              {page.showSymbol ? (
                  page.showGreenland ? (  <img
                    src={flagImg}
                    className="log-book-tab-symbol mod-flag"
                  />) : (  <img
                    src={nuclearImg}
                    className="log-book-tab-symbol mod-nuclear"
                  />)
              ) : (<p className="log-book-tab-text mod-front">{page.tabText}</p>)}
            </div>
            <div className="log-book-tab-face mod-back">
              <img
                src={page.tabImg}
                className={`log-book-tab-img ${page.tabImgOffset}`}
              />
              <div
                className="log-book-tab-marker mod-back"
                style={`background: ${page.tabColor}`}
              />
              {/* {page.showSymbol ? (
                    <img
                    src={nuclearImg}
                    className="log-book-tab-symbol mod-nuclear"
                  />
              ) : (<p className="log-book-tab-text mod-front">{page.tabText}</p>)} */}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default LogBookPage;
